const storage = {
    isPriceToggleOn: "isPriceToggleOn",
};

export const setPriceToggleOn = (value: boolean) => {
    return localStorage.setItem(storage.isPriceToggleOn, value.toString());
};

export const clearPriceToggleStorage = () => {
    if (typeof localStorage !== "undefined" && localStorage.getItem(storage.isPriceToggleOn) != null) {
        return localStorage.removeItem(storage.isPriceToggleOn);
    }
};
